import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { jobsApi } from '.';
export var apiSubscribeJobAlerts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var formData, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            formData = new FormData();
            formData.append('email', payload.email);
            formData.append('query', payload.query);
            formData.append('location', payload.location);
            formData.append('user_full_name', payload.user_full_name);
            _context.next = 8;
            return jobsApi.post('/job_alerts', payload);

          case 8:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            console.error("Failed to subscribe to job alerts: ".concat(_context.t0));
            return _context.abrupt("return", [null, _context.t0]);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));

  return function apiSubscribeJobAlerts(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var apiGetJobAlerts = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(email) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            if (email) {
              _context2.next = 3;
              break;
            }

            throw new Error('Missing email address');

          case 3:
            _context2.next = 5;
            return jobsApi.get('/job_alerts', {
              params: {
                email: email
              }
            });

          case 5:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data]);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            console.error("Failed to fetch job alerts: ".concat(_context2.t0));
            return _context2.abrupt("return", [null, _context2.t0]);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));

  return function apiGetJobAlerts(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiUpdateJobAlert = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id, payload) {
    var formData, res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            if (id) {
              _context3.next = 3;
              break;
            }

            throw new Error('Missing job alert id');

          case 3:
            formData = new FormData();
            formData.append('email', payload.email);
            formData.append('query', payload.query);
            formData.append('location', payload.location);
            formData.append('user_full_name', payload.user_full_name);
            _context3.next = 10;
            return jobsApi.patch("/job_alerts/".concat(id), payload);

          case 10:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data]);

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](0);
            console.error("Failed to update job alert: ".concat(_context3.t0));
            return _context3.abrupt("return", [null, _context3.t0]);

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 14]]);
  }));

  return function apiUpdateJobAlert(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiDeleteJobAlert = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            if (id) {
              _context4.next = 3;
              break;
            }

            throw new Error('Missing job alert id');

          case 3:
            _context4.next = 5;
            return jobsApi["delete"]("/job_alerts/".concat(id));

          case 5:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data]);

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);
            console.error("Failed to delete job alert: ".concat(_context4.t0));
            return _context4.abrupt("return", [null, _context4.t0]);

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 9]]);
  }));

  return function apiDeleteJobAlert(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiGetJobs = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5) {
    var query, per_page, location, _ref5$page, page, categories, order_column, order_direction, res;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            query = _ref5.query, per_page = _ref5.per_page, location = _ref5.location, _ref5$page = _ref5.page, page = _ref5$page === void 0 ? 1 : _ref5$page, categories = _ref5.categories, order_column = _ref5.order_column, order_direction = _ref5.order_direction;
            _context5.prev = 1;
            _context5.next = 4;
            return jobsApi.get('/jobs', {
              params: {
                query: query,
                per_page: per_page || 20,
                location: location,
                page: page,
                category: categories === null || categories === void 0 ? void 0 : categories.join(','),
                order_column: order_column,
                order_direction: order_direction
              }
            });

          case 4:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data]);

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](1);
            console.error("Failed to fetch jobs: ".concat(_context5.t0));
            return _context5.abrupt("return", [null, _context5.t0]);

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 8]]);
  }));

  return function apiGetJobs(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
export var apiGetJobCategories = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return jobsApi.get('/categories');

          case 3:
            res = _context6.sent;
            return _context6.abrupt("return", [res.data]);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            console.error("Failed to fetch categories: ".concat(_context6.t0));
            return _context6.abrupt("return", [null, _context6.t0]);

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7]]);
  }));

  return function apiGetJobCategories() {
    return _ref7.apply(this, arguments);
  };
}();